import React from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, Divider } from '@mui/material';

const AssessmentResultViewer = ({ assessmentResult }) => {
  if (!assessmentResult) {
    return <Typography>No assessment result to display.</Typography>;
  }

  const {
    testFullName,
    testVersion,
    dateTaken,
    score,
    interpretation,
    answers,
    initiatedBy,
    deliveryMode
  } = assessmentResult;

  return (
    <Paper elevation={1} sx={{ p: 2, my: 2 }}>
      <Typography variant="h6" gutterBottom>
        {testFullName} (v{testVersion})
      </Typography>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Taken: {new Date(dateTaken).toLocaleString()}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        <strong>Score:</strong> {score}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        <strong>Interpretation:</strong> {interpretation}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle1" gutterBottom>
        Responses:
      </Typography>
      <List dense>
        {answers && answers.map((ans, index) => (
          <ListItem key={ans.questionId || index} disableGutters>
            <ListItemText
              primary={`${index + 1}. ${ans.questionText}`}
              secondary={`Answer: ${ans.answerLabel || ans.answerValue}`}
            />
          </ListItem>
        ))}
      </List>
      <Divider sx={{ my: 2 }} />
      <Typography variant="caption" color="text.secondary">
        Initiated by: {initiatedBy || 'N/A'} | Delivery mode: {deliveryMode || 'text'}
      </Typography>
    </Paper>
  );
};

export default AssessmentResultViewer;
